import apiClient from "./axiosInstance"

export interface WhatsAppButtonSettings {
  _id?: string
  isVisible: boolean
  approvedProfileUrl: string
  unapprovedProfileUrl: string
  createdAt?: string
  updatedAt?: string
}

export const getWhatsAppButtonSettings = async () => {
  const response = await apiClient.get("/admin/whatsapp/whatsapp-button")
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Failed to fetch WhatsApp button settings")
  }
}

export const updateWhatsAppButtonSettings = async (settings: WhatsAppButtonSettings) => {
  const response = await apiClient.put("/admin/whatsapp/whatsapp-button", settings)
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Failed to update WhatsApp button settings")
  }
}
